import EditAssetModal from './EditAssetModal';

export default EditAssetModal;
